/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { OnlyExtraBookingList as OnlyExtraBookingListMole } from "../../molecules";
import { OnlyExtraBookingWrapper } from "./OnlyExtraBooking.style";
import { OnlyExtraBookingListToolbar } from "./OnlyExtraBookingListToolbar";

export const OnlyExtraBookingList: React.FC = () => {
  const { bookingExtras } = useSelector((state: any) => state.bookings);
  const { loading } = useSelector((state: any) => state.async);
  const [searchBookingId, setSearchBookingId] = React.useState("");
  const filteredBookings = React.useMemo(() => {
    const query = searchBookingId.trim().toLowerCase();
    if (!query) return bookingExtras;
    return bookingExtras.filter((booking: any) =>
      String(booking.bookingId || "")
        .toLowerCase()
        .includes(query)
    );
  }, [bookingExtras, searchBookingId]);
  return (
    <AdminPageBody
      pageToolbar={
        <OnlyExtraBookingListToolbar
          searchBookingId={searchBookingId}
          onSearchBookingIdChange={setSearchBookingId}
        />
      }
    >
      <OnlyExtraBookingWrapper>
        <OnlyExtraBookingListMole
          bookings={filteredBookings}
          loading={loading}
        />
      </OnlyExtraBookingWrapper>
    </AdminPageBody>
  );
};
